import { createContext } from "react";

import useTypedContext from "hooks/useTypedContext";

const DrawerContext = createContext<string | undefined>(undefined);

export const useDrawerContext = () => useTypedContext(DrawerContext);

export const DrawerProvider = DrawerContext.Provider;
